module.exports = __webpack_public_path__ + "img/chambers.49dd2acc.svg";